import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Col, Container, Row } from 'react-bootstrap';
import LazyImage from '../../../ui-core/Image';
// import { IMAGE_CONSTANT } from '../../../constants/app';
import { getDisplayType } from '../../../utils/helpers';
import useWindowWidth from '../../../hooks/useWindowWidth';

const SectionBlock = React.forwardRef(({ section }, ref) => {
  const isMobileScreen = getDisplayType(useWindowWidth()) === 'mobile';
  const isIpadScreen = getDisplayType(useWindowWidth()) === 'ipad';
  const isDesktopScreen = getDisplayType(useWindowWidth()) === 'desktop';
  return (
    <Container ref={ref} className="section-block">
      <Row
        className={clsx(
          'd-flex',
          section.reverseOrder && 'flex-row-reverse',
          (isMobileScreen || isIpadScreen) && 'flex-column',
        )}
      >
        <Col
          xs={12}
          md={isDesktopScreen ? 6 : 12}
          className="d-block position-relative align-self-start"
        >
          {isMobileScreen && <h3>{section.name}</h3>}
          <LazyImage
            alt={section.name}
            className={clsx(
              'my-auto section-image w-100',
              section.reverseOrder &&
                !(isMobileScreen || isIpadScreen) &&
                'ms-auto',
            )}
            errorSrc={section.image}
            placeholderSrc={section.placeholderImage}
            src={section.webpImage}
          />
        </Col>
        <Col xs={12} md={isDesktopScreen ? 6 : 12} className="d-flex">
          <div>
            {(isDesktopScreen || isIpadScreen) && <h3>{section.name}</h3>}
            <div className="section-text">{parse(section.description)}</div>
          </div>
        </Col>
      </Row>
    </Container>
  );
});

SectionBlock.propTypes = {
  section: PropTypes.object.isRequired,
};

SectionBlock.displayName = 'SectionBlock';

export default SectionBlock;
